module.exports = __webpack_public_path__ + "static/lights-d38b9d2bed268176a945f735be79560f.jpg";